export const ANOMALY_MONITORED_CONNECTOR_STATUSES = {
  inactive: 'inactive',
  ok: 'ok',
  anomaly: 'anomaly',
  disabled: 'disabled',
};
